<p-fluid>
    <div class="flex flex-col gap-6">
        <div class="flex items-center gap-3">
            <p-checkbox inputId="withdraw-enabled" [binary]="true" [disabled]="disabled()" [ngModel]="value().WithdrawEnabled" (ngModelChange)="setField('WithdrawEnabled', $event)" />
            <label for="withdraw-enabled">Withdraw Enabled</label>
        </div>

        <div>
            <label class="block font-medium mb-1">Min Withdraw Amount (USD)</label>
            <p-inputNumber class="w-full" [disabled]="disabled() || !value().WithdrawEnabled" [ngModel]="value().MinWithdrawAmountUsd" (ngModelChange)="setField('MinWithdrawAmountUsd', $event ?? 0)" />
        </div>
        <div>
            <label class="block font-medium mb-1">Withdraw Credits per Dollar</label>
            <p-inputNumber class="w-full" [disabled]="disabled() || !value().WithdrawEnabled" [ngModel]="value().WithdrawCreditsPerDollar" (ngModelChange)="setField('WithdrawCreditsPerDollar', $event ?? 0)" />
        </div>
    </div>
</p-fluid>
